export const FEED_IMAGE_DEFAULT_SIZE = {
    width: 200,
    height: 331,
};

export function getFeedImageSize(width: number, height: number) {
    if (!width || !height) {
        return FEED_IMAGE_DEFAULT_SIZE;
    }
    return width / height >= 0.75
        ? FEED_IMAGE_DEFAULT_SIZE
        : { width: 200, height: 200 };
}

/**
 * 简洁的方式，避免数值精度问题
 * @param num
 * @param toFixed       保留几位小数
 * @param params        配置
 *      replaceZero   是否将尾部0全部替换为空
 *      precision     精度，一般无需改
 */
export function strip(num: number, toFixed = 1, params): string {
    const defaultValue = {
        replaceZero: true,
        precision: 12,
        isRound: true,
    };
    const { replaceZero, precision, isRound }: any = {
        ...defaultValue,
        ...params,
    };
    // num 非number，会导致toPrecision 调用错误
    if (typeof num !== 'number') {
        return `${num}`;
    }
    const count = +parseFloat(num.toPrecision(precision));
    const factor = Math.pow(10, toFixed);
    const value = isRound
        ? count.toFixed(toFixed)
        : `${Math.floor(num * factor) / factor}`;
    return replaceZero ? value.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1') : value;
}

/**
 * 数值格式化为 b, m, k 形式
 * @param count     要格式化的数据
 * @param toFixed   保留几位小时
 * @param replaceZero
 */
export function formatValue(
    count: number | string,
    toFixed = 1,
    replaceZero = true
): string {
    let num = parseFloat(`${count}`);
    const sign = num >= 0 ? '' : '-';
    num = Math.abs(num);
    const commonParams = {
        replaceZero,
        isRound: false,
    };
    if (Number.isNaN(num) || num < 1e3) {
        return `${count}`;
    }
    if (num >= 1e3 && num < 1e6) {
        return `${sign}${strip(num / 1e3, toFixed, commonParams)}K`;
    }
    if (num >= 1e6 && num < 1e9) {
        return `${sign}${strip(num / 1e6, toFixed, commonParams)}M`;
    }
    return `${sign}${strip(num / 1e9, toFixed, commonParams)}B`;
}

export function convertLrpxToRem(valueInLrpx) {
    // 将lrpx转为rem
    // valueInLrpx 是按414尺寸的值，因此不需要用rootFont与clientWidth再做换算了
    const valueInRem = (valueInLrpx / 414) * 100;
    return `${valueInRem}rem`;
}
